import { render, staticRenderFns } from "./MemberSettingsFormWrapper.vue?vue&type=template&id=0a489bd2&scoped=true&lang=pug&"
import script from "./MemberSettingsFormWrapper.vue?vue&type=script&lang=js&"
export * from "./MemberSettingsFormWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a489bd2",
  null
  
)

export default component.exports